export type Placement =
	| "topStart"
	| "topCenter"
	| "topEnd"
	| "bottomStart"
	| "bottomCenter"
	| "bottomEnd";

export type Warning = "info" | "success" | "warning" | "error";

export type Color =
	| "red"
	| "orange"
	| "yellow"
	| "green"
	| "cyan"
	| "blue"
	| "violet";

export enum reducerPathEnums {
	Lesson = "lesson",
	Activity = "activity",
	Course = "course",
	Openai = "openai",
}

export enum activityTypeEnums {
	Reading = "reading",
	ReadingCustom = "reading-custom",
	Listening = "listening",
	Grammar = "grammar",
	Vocabulary = "vocabulary",
	Speaking = "speaking",
}
